import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import { Pencil } from "lucide-react-native";
import {
  QuestionLayout,
  IconInput,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useInfertility } from "../InfertilityContext";
import type { InfertilityStackParamList } from "../InfertilityNavigator";

export function InfertilityCauseOtherScreen() {
  const t = useTranslations();
  const { state, updateState } = useInfertility();
  const navigation = useNavigation<NavigationProp<InfertilityStackParamList>>();

  const handleSave = () => {
    navigation.navigate("PartnerInfertilityDiagnosis");
  };

  return (
    <QuestionLayout
      title={t("med_history.fertility.infertility.cause_other_title")}
      onBack={() => navigation.goBack()}
      onSave={handleSave}
      saveLabel={t("med_history.fertility.save_info")}
    >
      <View style={styles.inputContainer}>
        <IconInput
          label={t("med_history.fertility.infertility.cause_other_label")}
          icon={Pencil}
          placeholder={t(
            "med_history.fertility.infertility.cause_other_placeholder",
          )}
          value={state.causeOther ?? ""}
          onChangeText={(text) => updateState({ causeOther: text })}
          multiline
          numberOfLines={4}
        />
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  inputContainer: {
    width: "100%",
    marginBottom: 40,
  },
});

export default InfertilityCauseOtherScreen;
